import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import VerticalNameChildren from '../../../components/library/layout/VerticalNameChildren'
import DateTime from '../../../components/library/common/DateTime'
import './CaseBasicInformation'
import ProvinceText from '../../../components/library/common/ProvinceText';
import EmdashText from '../../../components/library/common/EmdashText';
import HrbTranslate from '../../../components/language/HrbTranslate';
import Skeleton from '../../../components/library/loaders/Skeleton';
import VerticalNameValue from '../../../components/library/layout/VerticalNameValue';

const CaseInfo = (props) => {
    const { oteCase } = props;

    const [loading, setLoading] = useState(true)
    const [packageKey, setPackageKey] = useState(null)
    const [returnTypeKey, setReturnTypeKey] = useState(null)
    const [langKey, setLangKey] = useState(null)
    const [assigneeValue, setAssigneeValue] = useState(null)
    const [statusKey, setStatusKey] = useState(null)

    useEffect(() => {
        setLoading(!oteCase)
        if (oteCase && oteCase.return_details.package) {
            setPackageKey('OteReturnInfo.Package.Standard');
        } else {
            setPackageKey(null);
        }

        setReturnTypeKey(oteCase ? 'ReturnInfo.Type.' + oteCase.return_details.coupled_status : null)
        setLangKey(oteCase ? 'Account.Language.' + oteCase.return_details.lang : null)
        setAssigneeValue(oteCase ? oteCase.return_details.returnStatus.assignedTaxExpert : null);
        setStatusKey(oteCase && oteCase.return_details.returnStatus.caseStatus
            ? 'OteReturnInfo.ReturnStatus.' + oteCase.return_details.returnStatus.caseStatus
            : null)
    }, [oteCase])
    
    return (
        <Fragment>
            <div className='columns tickets'>
                <div className='column is-10 is-offset-1'>
                    <h4>
                        {!loading && 
                            <HrbTranslate text='Tickets.Labels.TaxYear' params={{
                                TaxYear: oteCase.return_details.tax_year
                            }} />
                        }
                        {loading && 
                            <Skeleton />
                        }
                    </h4>
                </div>
            </div>
            <div className='columns tickets'>
                <div className='column is-4 is-offset-1'>
                    <VerticalNameChildren
                        textKey="ReturnInfo.Labels.Product"                        
                        loading={loading}>
                        {!loading &&
                            <HrbTranslate text="ReturnInfo.Product.OTE" className='p1 medium-weight' />
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey="ReturnInfo.Labels.Package"                        
                        loading={loading}>
                        {!loading && packageKey &&
                            <HrbTranslate className='p1 medium-weight' text={packageKey} />
                        }
                        {!loading && !packageKey && 
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-2'>
                    <VerticalNameChildren
                        textKey="Tickets.Labels.ReturnType"                        
                        loading={loading}>
                        {!loading && returnTypeKey &&
                            <HrbTranslate className='p1 medium-weight' text={returnTypeKey} />
                        }
                        {!loading && !returnTypeKey &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
            </div>
            <div className='columns tickets'>
                <div className='column is-4 is-offset-1'>
                    <VerticalNameChildren
                        textKey="OteReturnInfo.Labels.Upgrades"
                        loading={loading}>
                        {!loading &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey="ReturnInfo.Labels.Language"
                        loading={loading}>
                        {!loading && langKey &&
                            <HrbTranslate className='p1 medium-weight' text={langKey} />
                        }
                        {!loading && !langKey &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-2'>
                    <VerticalNameChildren
                        textKey="Account.Labels.ProvinceTerritory"                        
                        loading={loading}>
                        {!loading  &&
                            <p className='p1 medium-weight'><ProvinceText province={oteCase.return_details.province} /></p>
                        }
                    </VerticalNameChildren>
                </div>
            </div>
            <div className='columns tickets'>
                <div className='column is-10 is-offset-1'>
                    <h4>
                        <HrbTranslate text='OteReturnInfo.Header.ReturnStatus' />
                    </h4>
                </div>
            </div>
            <div className='columns tickets'>
                <div className='column is-4 is-offset-1'>
                    <VerticalNameValue
                        textKey="OteReturnInfo.Labels.Assignee"
                        loading={loading}
                        value={assigneeValue} />
                </div>
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey="ReturnInfo.Labels.LastModified"
                        loading={loading}>
                        {!loading &&
                            <p className='p1 medium-weight'>
                                <DateTime value={oteCase.return_details.lastModifiedDate} dateAndTime />
                            </p>
                        }                        
                    </VerticalNameChildren>
                </div>
                <div className='column is-2'>
                    <VerticalNameChildren
                        textKey="PresaleInfo.Labels.Status"
                        loading={loading}>
                        {!loading && statusKey &&
                            <HrbTranslate className='p1 medium-weight' text={statusKey} />
                        }
                        {!loading && !statusKey &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
            </div>
        </Fragment>
    );
}

CaseInfo.whyDidYouRender = false;

CaseInfo.propTypes = {
    ticket: PropTypes.object
}

export default CaseInfo